import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import firebase from 'firebase';
import { useSelector } from 'react-redux';
import LazyCard from '../LandingPage/Sections/LazyCard';
import { Row, Typography, Spin, Button, Empty } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const { Title } = Typography;

function CartPage(props) {
  const user = useSelector((state) => state.user);
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!user && !user.isLogin) {
      alert('로그인 후 이용 가능합니다.');
      props.history.push('/login');
    } else {
      firebase
        .database()
        .ref('zzals/' + localStorage.getItem('u_id'))
        .once('value')
        .then((snapshot) => {
          const obj = snapshot.val();
          const array = [];
          for (let key in obj) {
            array.push({ ...obj[key], key });
          }
          setImages(array);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user]);

  const removeHandler = (key) => {
    firebase
      .database()
      .ref('zzals/' + localStorage.getItem('u_id'))
      .child(key)
      .remove()
      .then((doc) => {
        setImages((oldItem) => {
          return oldItem.filter((item) => item.key !== key);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const renderItems = images.map((image, index) => {
    return (
      <React.Fragment key={index}>
        <LazyCard image={image} />
        <div
          style={{
            zIndex: '30',
            marginRight: '40px',
          }}
        >
          <Button
            type='primary'
            danger
            icon={<DeleteOutlined />}
            onClick={() => removeHandler(image.key)}
          ></Button>
        </div>
      </React.Fragment>
    );
  });

  return (
    <>
      <div style={{ maxWidth: '1200px', margin: '3rem auto', height: 'auto' }}>
        <div style={{ textAlign: 'center', marginTop: '100px' }}>
          <Title level={3}>내 짤주머니</Title>
        </div>
        <div style={{ marginTop: '5rem' }}>
          {isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin size='large' tip='Loading...' />
            </div>
          ) : (
            !images.length && <Empty />
          )}

          <Row gutter={[16, 16]}>{renderItems}</Row>
        </div>
      </div>
    </>
  );
}

export default withRouter(CartPage);
